/* hayakmodule */
define('../src/hayak/sublayouts/m43-account-selector/m43-account-selector',['jquery', 'lib/utils'], function($, utils) {

    'use strict';

    var AccountSelector = function($component) {

        this.$component = $component;

        return this;
    };

    AccountSelector.prototype.init = function() {
        var _this = this,
            moveout = false;


        this.refresh();

        //if( utils.isTouchDevice() ) {
        //  this.optimiseForTouchDevices();
        //}

        $(window).on('bind-selector-checkbox', function() {
            _this.resetMultiSelection();
        });

        $(window).off('hellopopulate').on('hellopopulate', function() {
            _this.populate_moveout();
        });

        $(window).off('data_loaded').on('data_loaded', function(){
            _this.init();
        });

        //$( document ).ajaxStop(function(){
        //    _this.$component.find('.m43-accountsel-hidden').show()
        //    _this.$component.find('.m66-preloader').hide()
        //});

        $( document ).ready(function(){
            _this.$component.find('.m43-accountsel-hidden').show()
            _this.$component.find('.m66-preloader').hide()
        });

        $('.m43-accountsel').each(function() {
            _this.defaultSelectedAccount(this);
        });
        
    };

    AccountSelector.prototype.defaultSelectedAccount = function($parent) {
        var _this = this,
            $accounts = $($parent).attr('data-selected-account');

        if ($accounts != undefined) {
            var accArr = $accounts.toString().replace(' ','').split(',');
            //console.log(accArr)
            if ( accArr.length != 0 ) {
                $(accArr).each(function() {
                    $($parent).find('.m49-list-filter--input').val(this);
                    $($parent).find('.m49-list-filter--button').click();
                    $($parent).find('.m43-accountsel__accounts-list').find('.form-field__fakecheckbox').click();
                    $($parent).find('.m43-accountsel__accounts-list').find('.form-field__fakeradio').click();
                    $($parent).find('.button--primary[data-accountupdate=true]').click();
                    $($parent).find('.m49-list-filter-reset-button').click();
                });
            } else {

            };
        }

    };

    AccountSelector.prototype.optimiseForTouchDevices = function() {

        var _this = this,
            $content = this.$component.find('.m39-modal__content').clone();

        this.$component.find('.m39-modal__content').remove();

        $('body').on('modal_opened', function() {

            _this.$component.find('.m39-modal__dialog--account').append($content);
            _this.refresh();
        });

        $('body').on('modal_closed', function() {

            _this.$component.find('.m39-modal__content').remove();
        });
    };

    AccountSelector.prototype.refresh = function() {
        var _this = this;
        // data- selector for dropdown update
        this.detailsWrapper = '[ data-acc-detail="wrapper" ]';
        this.additionalDetails = {
            'accType': '[ data-acc-detail="acc_type" ]',
            'accBusinessPartner': '[ data-acc-detail="acc_businesspartner" ]'
        };
        this.additionalDetails2 = {
            'accType': '[ data-acc-detail="type" ]',
            'accPremise': '[ data-acc-detail="acc_premise" ]',
            'accPremiseType': '[ data-acc-detail="acc_premiseType" ]',
            'accBusinessPartner': '[ data-acc-detail="acc_businesspartner" ]'
        };

        // cache dom els
        this.$selectedAccount = this.$component.find('[ data-accountselector ]');
        this.$selectedAccountDetails = this.$selectedAccount.find(this.detailsWrapper);
        this.$selectedAccountAdditionalsDetails = this.$component.find('[ data-accountsel-additional-details ]');
        this.$multiSelectedText = this.$component.find('[ data-acc-multiselected ]');
        this.$multiSelectedTextcopy = this.$component.find('[ data-acc-multiselected-copy ]');
        this.$errorText = this.$component.find('[ data-modal="errormessage" ]');
        this.$accountImages = this.$component.find(' [ data-acc-detail="acc_image" ] ');

        this.$update = this.$component.find('[ data-accountupdate ]');
        this.$close = this.$component.find('[ data-close ]');
        this.$accounts = this.$component.find('[ data-input ]');
        this.$checkboxes = this.$component.find('[ data-input="checkbox" ]');

        // tabs
        this.$tabbers = this.$component.find('[ data-tabber ]');
        this.$tabPanels = this.$component.find('[ data-tabpanel ]');
        this.$tabStorer = this.$component.find('[ data-tabstorer ]');
        this.hasTabs = this.$tabStorer.length > 0;

        // whether to let the form submit on modal cta
        this.preventSubmit = this.$selectedAccount.data('preventsubmit');

        // listeners
        this.$selectedAccount.on('click', $.proxy(this.stashSelectedInput, this));
        this.$update.on('click', $.proxy(this.populate, this));
        this.$close.on('click', $.proxy(this.resetSelected, this));
        this.$tabbers.on('click', $.proxy(this.switchTabs, this));

        // undo changes to checkboxes selection on cancel(close)
        this.$currentCheckedCheckboxes = {};
        this.$previousCheckedCheckboxes = {};

        // min/max selection validation
        this.minMaxValidated = true;
        this.minSelection = this.$selectedAccount.data('minselection');
        if (this.minSelection === undefined) {
            this.minSelection = 1;
        }
        this.maxSelection = this.$selectedAccount.data('maxselection');
        if (this.maxSelection === undefined) {
            this.maxSelection = 99999; // arbitrary but enough
        }

        // load account images
        this.sequentiallyLoadImages();

        //Global Object for account multi-selection tab-wise
        dewaGlobal.multiSelectionInputData = [];
        //Reset the muti-selection tab-wise
        this.resetMultiSelection();

        var resetControl = this.$component.find("[ data-reset-control ]");
        var resetUpdate = this.$component.find("[ data-reset-update ]");
        $(resetUpdate).on('click', function() {

            _this.$currentCheckedCheckboxes = {};
            _this.$previousCheckedCheckboxes = {};
            dewaGlobal.multiSelectionInputData = [];
            _this.init();
            var msg = $('#multiselected-copy');
            msg.removeClass('hidden')
                .attr('aria-hidden', false)
                .text(msg.data('acc-multiselected-copy'));

            var msgnew = $('#multiselected');
            if (_this.moveout) {
                msgnew.html($('.moveout_hidden_container').html());
            } else {
                msgnew.addClass('hidden').attr('aria-hidden', true).text(' ');
            }
            

        });

        var pagerUpdate = this.$component.find("[ data-pager-update ]");
        $(pagerUpdate).on('click', function() {
            //Reset the value of account list
            _this.$selectedAccountDetails = _this.$selectedAccount.find(_this.detailsWrapper);
            _this.$accounts = _this.$component.find("[ data-input ]");
            //Reset the checkbox for multi-selection.
            _this.$checkboxes = _this.$component.find('[ data-input="checkbox" ]');
            //Reset the value of tabs
            _this.$tabbers = _this.$component.find("[ data-tabber ]");
            _this.$tabPanels = _this.$component.find("[ data-tabpanel ]");
            _this.$tabStorer = _this.$component.find("[ data-tabstorer ]");
            _this.hasTabs = _this.$tabStorer.length > 0;
            //Check tab found, if any. 
            if (_this.hasTabs) {
                //then find the current value & call click event of tab-button.
                var dewaTabber = _this.$tabbers[$(_this.$tabStorer).val()];
                $(dewaTabber).click();
                //debugger;
            }
            _this.resetMultiSelection();
            //Set the checkbox selection
            _this.resetMultiSelected();
        });
        //Check tab found at first time. then find the current value & call click event of tab-button.
        if (this.hasTabs) {
            var dewaTabber = this.$tabbers[$(this.$tabStorer).val()];
            $(dewaTabber).click();

            //Find the default checked item & add in the list at first time.
            var currentCheckedInputList = this.$accounts.filter(":checked");
            $(currentCheckedInputList).each(function(i, elem) {
                var currentTab = $(elem).parents('.m43-accountsel__tabpanel')[0];
                var tabIndex = $(currentTab).data('tabpanel');
                var currentInput = $(elem);
                var isChecked = currentInput.is(":checked") ? 1 : 0;
                _this.updateMultiSelectionData(tabIndex, currentInput, isChecked);
            });
        };
    };


    AccountSelector.prototype.switchTabs = function(e) {

        var $selectedTabber = $(e.target),
            $selectedTabberCode = $selectedTabber.data('tabber'),
            $selectedTabPanel = this.$component.find('[ data-tabpanel="' + $selectedTabberCode + '" ]');

        e.preventDefault();

        this.$tabbers.removeClass('m41-tabs-box__tab-link--active').attr('aria-selected', 'false');
        $selectedTabber.addClass('m41-tabs-box__tab-link--active').attr('aria-selected', 'true');

        this.$tabPanels.addClass('m43-accountsel__tabpanel--hidden').attr('aria-hidden', 'true');
        $selectedTabPanel.removeClass('m43-accountsel__tabpanel--hidden').attr('aria-hidden', 'false');

        this.$tabStorer.val($selectedTabberCode);

        // reset min/max selection message status
        this.$accounts.off('change');

        this.$errorText
            .addClass('hidden')
            .attr('aria-hidden', true);

        this.$update
            .removeClass('hidden')
            .attr('aria-hidden', false);

    };

    AccountSelector.prototype.resetSelected = function() {

        var key;

        if (this.minMaxValidated === true) {

            this.$currentCheckedInput.prop('checked', true);

            for (key in this.$currentCheckedCheckboxes) {
                if (this.$currentCheckedCheckboxes.hasOwnProperty(key)) {
                    $('#' + key).prop('checked', this.$currentCheckedCheckboxes[key]);
                }
            }
        } else {

            this.$previousCheckedInput.prop('checked', true);

            for (key in this.$previousCheckedCheckboxes) {
                if (this.$previousCheckedCheckboxes.hasOwnProperty(key)) {
                    $('#' + key).prop('checked', this.$previousCheckedCheckboxes[key]);
                }
            }

        }
    };
    AccountSelector.prototype.resetMultiSelected = function() {
        var _this = this;
        var currentTabIndex = (_this.hasTabs ? $(_this.$tabStorer).val() : 0);
        var currentTabObj = $.map(dewaGlobal.multiSelectionInputData, function(Obj, key) {
            if (Obj.tabindex == currentTabIndex) return Obj;
        });
        for (var i in currentTabObj) {
            $("#" + currentTabObj[i].id).prop("checked", true);
        }
    };
    AccountSelector.prototype.resetMultiSelection = function() {
        var _this = this;
        this.$inputBoxMutiSelection = this.$component.find('.form-field__fakecheckbox');
        $(this.$inputBoxMutiSelection).on('click', function(event) {
            var tabIndex = (_this.hasTabs ? $(_this.$tabStorer).val() : 0);
            var currentInput = $(this.previousElementSibling);
            var isChecked = currentInput.is(":checked") ? 0 : 1; //Here event value is reverese or i use true=0 & false=1 
            _this.updateMultiSelectionData(tabIndex, currentInput, isChecked);
        });
    };
    AccountSelector.prototype.updateMultiSelectionData = function(tabIndex, currentInput, isChecked) {
        var _this = this;
        var currentAccObj = { tabindex: tabIndex, id: currentInput.attr('id'), account: currentInput.data('account-number'), name: currentInput.data('account-name'), type: currentInput.data('account-class') };
        var isExist = $.grep(dewaGlobal.multiSelectionInputData, function(obj) {
            return (obj.account === currentAccObj.account && obj.tabindex === currentAccObj.tabindex);
        });

        if (isChecked == 0) { //false remove it
            dewaGlobal.multiSelectionInputData = $.grep(dewaGlobal.multiSelectionInputData, function(obj, i) {
                return (obj.account === currentAccObj.account && obj.tabindex === currentAccObj.tabindex); }, true);
        } else {
            if (isExist.length == 0 && isChecked == 1) { //checked it true
                dewaGlobal.multiSelectionInputData.push(currentAccObj);
            }
        }
    };
    AccountSelector.prototype.stashSelectedInput = function() {
        var _this = this;

        this.$currentCheckedInput = this.$accounts.filter(':checked');
        // create an object of checkboxes 'id':'checked'
        this.$checkboxes.each(function(i, e) {
            _this.$currentCheckedCheckboxes[$(e).attr('id')] = $(e).is(':checked');
        });
        //Reset the multiselected input box
        this.resetMultiSelected();
    };

    AccountSelector.prototype.findCurrentTabCheckedInputs = function() {
        var _this = this;
        this.$currentTabChecked = this.$tabPanels.filter('[ data-tabpanel="' + this.$tabStorer.val() + '" ]').find(':checked');
        //Added for multi-selection page-wise
        this.$currentTabCheckedCount = $.grep(dewaGlobal.multiSelectionInputData, function(obj) {
            return (obj.tabindex == _this.$tabStorer.val());
        });
    };


    AccountSelector.prototype.populate = function(e) {

        var _this = this,
            totAccounts,
            $updateAccount;

        this.$previousCheckedInput = this.$currentCheckedInput;
        this.$previousCheckedCheckboxes = $.extend({}, this.$currentCheckedCheckboxes);
        this.stashSelectedInput();

        if (this.hasTabs) {
            // we have tabs - then count how many were checked in the current tab ipanel
            this.findCurrentTabCheckedInputs();
            //totAccounts = this.$currentTabChecked.length; //Bharat: I have changed for multi-selection page-wise validation
            totAccounts = this.$currentTabCheckedCount.length;

        } else {
            totAccounts = this.$currentCheckedInput.length;
        }
        if (totAccounts == 0 && this.minSelection == 1 && this.maxSelection == 1) {

            e.preventDefault();

            this.$close.click();


        } else {
            if (totAccounts >= this.minSelection && totAccounts <= this.maxSelection) {

                this.minMaxValidated = true;

                this.clearMessage(this.$multiSelectedText);

                if (this.preventSubmit === true) {
                    e.preventDefault();
                }

                switch (totAccounts) {
                    //debugger;
                    // radio or single checkbox - show account deatails
                    case 1:
                        if (this.hasTabs) {
                            // this.$currentCheckedInput stores ALL checked inputs for all tabs, so it doesn't work. We need to find the checked one in the current tab.
                            // (I'm so sorry about this line of code)
                            $updateAccount = this.$currentTabChecked.parent().find(this.detailsWrapper).clone();

                            var $link = _this.$component.find('.m43accountdetailslink'),
                                pholder = $link.attr('data-url');

                            if ( pholder != undefined && pholder != null ) {
                                $link.attr('href', pholder+this.$currentTabChecked.parent().find(this.detailsWrapper).find('[data-acc-detail="acc_number"]').html().replace('(', '').replace(')', ''))
                            }
                        } else {
                            $updateAccount = this.$currentCheckedInput.parent().find(this.detailsWrapper).clone();

                            var $link = _this.$component.find('.m43accountdetailslink'),
                                pholder = $link.attr('data-url');

                            if ( pholder != undefined && pholder != null ) {
                                $link.attr('href', pholder+this.$currentCheckedInput.parent().find(this.detailsWrapper).find('[data-acc-detail="acc_number"]').html().replace('(', '').replace(')', ''))
                            }
                        }

                        for (var key in this.additionalDetails2) {

                            if (this.additionalDetails2.hasOwnProperty(key)) {
                                var k = this.additionalDetails2[key],
                                    $newDetailNode = $updateAccount.find(k);

                                this.$selectedAccountAdditionalsDetails.find(k).text($newDetailNode.text());
                                if ($newDetailNode.text().length == 0) {
                                    this.$selectedAccountAdditionalsDetails.find(k).hide();
                                    //this.$selectedAccountAdditionalsDetails.find(k).prev().hide();
                                } else {
                                    this.$selectedAccountAdditionalsDetails.find(k).show();
                                    //this.$selectedAccountAdditionalsDetails.find(k).prev().show();
                                }
                                
                            }

                        }

                        for (var key in this.additionalDetails) {

                            if (this.additionalDetails.hasOwnProperty(key)) {
                                var k = this.additionalDetails[key],
                                    $newDetailNode = $updateAccount.find(k);

                                //this.$selectedAccountAdditionalsDetails.find(k).text($newDetailNode.text());
                                $updateAccount.find($newDetailNode).parent().remove();
                            }

                        }
                        break;
                        // if more than one selected (checkboxes!) - show how many
                    default:
                        $updateAccount = '';

                        this.$multiSelectedText
                            .removeClass('hidden')
                            .attr('aria-hidden', false)
                            .text(this.$multiSelectedText.data('acc-multiselected').replace("{number}",totAccounts));
                            //.text(totAccounts + this.$multiSelectedText.data('acc-multiselected'));

                        /*this.$multiselectedcopy
                            .addClass('hidden' )
                            .attr( 'aria-hidden', true )
                            .text('');*/
                        var msgnew = $('#multiselected-copy');
                        msgnew.addClass('hidden').attr('aria-hidden', true).text(' ');
                }

                this.$selectedAccountDetails.html($updateAccount);

                this.$close.click();

            } else { // handle error message when out of min/max selection bounds

                this.minMaxValidated = false;

                e.preventDefault();

                if (totAccounts < this.minSelection) {
                    this.$errorText.text(this.$errorText.data('min-error'));
                } else { // if > this.maxSelection
                    this.$errorText.text(this.$errorText.data('max-error'));
                }

                this.$errorText
                    .removeClass('hidden')
                    .attr('aria-hidden', false)
                    .focus();

                this.$update
                    .addClass('hidden')
                    .attr('aria-hidden', true);

                this.$accounts.on('change', function() {
                    var currentSelectedAmount;

                    if (_this.hasTabs) {

                        _this.findCurrentTabCheckedInputs();
                        //currentSelectedAmount = _this.$currentTabChecked.length; //Bharat: I have changed for multi-selection page-wise validation
                        currentSelectedAmount = _this.$currentTabCheckedCount.length;
                    } else {

                        currentSelectedAmount = _this.$accounts.filter(':checked').length;
                    }

                    if (currentSelectedAmount >= _this.minSelection) {

                        _this.$accounts.off('change');

                        _this.$errorText
                            .addClass('hidden')
                            .attr('aria-hidden', true);

                        _this.$update
                            .removeClass('hidden')
                            .attr('aria-hidden', false);
                    }

                });

            }
        }

    };

    AccountSelector.prototype.populate_moveout = function(e) {

        var _this = this,
            totAccounts,
            $updateAccount;

        this.$previousCheckedInput = this.$currentCheckedInput;
        this.$previousCheckedCheckboxes = $.extend({}, this.$currentCheckedCheckboxes);
        this.stashSelectedInput();

        this.moveout = true;

        if (this.hasTabs) {
            // we have tabs - then count how many were checked in the current tab ipanel
            this.findCurrentTabCheckedInputs();
            //totAccounts = this.$currentTabChecked.length; //Bharat: I have changed for multi-selection page-wise validation
            totAccounts = this.$currentTabCheckedCount.length;

        } else {
            totAccounts = this.$currentCheckedInput.length;
        }
        if (totAccounts == 0 && this.minSelection == 1 && this.maxSelection == 1) {

            e.preventDefault();

            this.$close.click();


        } else {
            if (totAccounts >= this.minSelection && totAccounts <= this.maxSelection) {

                this.minMaxValidated = true;

                this.clearMessage(this.$multiSelectedText);

                if (this.preventSubmit === true) {
                    e.preventDefault();
                }

                if (totAccounts == 1) {
                    this.$multiSelectedText
                        .removeClass('hidden')
                        .attr('aria-hidden', false)
                        .text(this.$multiSelectedText.data('acc-multiselected-sing').replace("{number}", totAccounts));
                    $(".m43-accountsel__selected").find(".m43-accountsel__account").html("");
                } else {
                    this.$multiSelectedText
                        .removeClass('hidden')
                        .attr('aria-hidden', false)
                        .text(this.$multiSelectedText.data('acc-multiselected').replace("{number}", totAccounts));
                        //.text(totAccounts + this.$multiSelectedText.data('acc-multiselected'));
                    $(".m43-accountsel__selected").find(".m43-accountsel__account").html("");
                };

                this.$selectedAccountDetails.html($updateAccount);

                this.$close.click();

            } else { // handle error message when out of min/max selection bounds

                this.minMaxValidated = false;

                e.preventDefault();

                if (totAccounts < this.minSelection) {
                    this.$errorText.text(this.$errorText.data('min-error'));
                } else { // if > this.maxSelection
                    this.$errorText.text(this.$errorText.data('max-error'));
                }

                this.$errorText
                    .removeClass('hidden')
                    .attr('aria-hidden', false)
                    .focus();

                this.$update
                    .addClass('hidden')
                    .attr('aria-hidden', true);

                this.$accounts.on('change', function() {
                    var currentSelectedAmount;

                    if (_this.hasTabs) {

                        _this.findCurrentTabCheckedInputs();
                        //currentSelectedAmount = _this.$currentTabChecked.length; //Bharat: I have changed for multi-selection page-wise validation
                        currentSelectedAmount = _this.$currentTabCheckedCount.length;
                    } else {

                        currentSelectedAmount = _this.$accounts.filter(':checked').length;
                    }

                    if (currentSelectedAmount >= _this.minSelection) {

                        _this.$accounts.off('change');

                        _this.$errorText
                            .addClass('hidden')
                            .attr('aria-hidden', true);

                        _this.$update
                            .removeClass('hidden')
                            .attr('aria-hidden', false);
                    }

                });

            }
        }

    };

    AccountSelector.prototype.clearMessage = function($message) {

        // empty and hide the DOM element showing the given message
        $message
            .addClass('hidden')
            .attr('aria-hidden', true)
            .text('');
    };

    // due to slow webservices defer loading of images until after DOM load and load them sequentially
    AccountSelector.prototype.sequentiallyLoadImages = function(index) {
        var _this = this,
            accountImages = _this.$accountImages,
            promises = [],
            chunkSize = 10,
            chunkEnd,
            set, i;

        function defferedImage(i, img) {
            var deferred = $.Deferred(),
                dataSrc = $(img).data('src');

            // resolve on load
            img.onload = function() {
                deferred.done();
            }

            // set src of image or resolve promise it no async src defined
            if (dataSrc) {
                img.src = dataSrc;
            } else {
                deferred.done();
            }

            return deferred.promise();
        }

        index = index || 0;
        chunkEnd = index + chunkSize;
        set = accountImages.slice(index, chunkEnd);

        // set up image load promises
        promises.push(set.each(defferedImage));

        // handle promise set resolution
        $.when.apply($, promises).always(function(response) {
            if (chunkEnd < accountImages.length) {
                _this.sequentiallyLoadImages(chunkEnd);
            }
        });
    };

    return AccountSelector;

});

